import styled from "styled-components";
import AppBar from "@mui/material/AppBar";
import type { Theme } from "../../constants/themeConstants";
import { Link } from "react-router-dom";
import { Toolbar } from "@mui/material";

export const HeaderContainer = styled(AppBar)`
  && {
    padding: 0;
    background-color: ${(props) => (props.theme as Theme)?.colors?.white};
    margin: 5px 0;

    --Paper-shadow: 0 !important;
    @media (min-width: 600px) {
      .MuiContainer-root {
        padding: 16px 0;
      }

      .MuiToolbar-root {
        gap: 48px;
      }
    }
    .MuiContainer-root {
      max-width: 1280px;
    }
    @media (min-width: 1536px) {
      .MuiContainer-root {
        max-width: 1280px;
      }
    }
  }
`;

export const ToolbarContainer = styled(Toolbar)`
  @media (min-width: 600px) {
    padding: 0 32px;
  }
`

export const LogoContainer = styled(Link)``;

export const Logo = styled.picture`
  width: auto;
`;
